import { RouterProvider, createBrowserRouter } from 'react-router-dom';

import { AuthRoutes } from '../features/auth';
import { HomeRoutes } from '../features/home';
import { PouchResultRoutes } from '../features/pouch-result';

const router = createBrowserRouter([
    {
        path: '/home/*',
        element: <HomeRoutes />,
    },
    {
        path: '/auth/*',
        element: <AuthRoutes />,
    },
    {
        path: '/pouch-result/*',
        element: <PouchResultRoutes />,
    },
    {
        path: '/*',
        element: <HomeRoutes />,
    },
]);

export const Router = () => {
    return <RouterProvider router={router} />;
};
